

import React from "react";
import { useLocation } from "react-router-dom";
import FooterBanner from "./contents/FooterBanner";
import FooterContact from "./contents/FooterContact";
import FooterSocialLinks from "./contents/FooterSocialLinks";

export default function Footer() {
  const location = useLocation();

  return (
    <footer>
      <FooterBanner />

      {/* Hide FooterContact on /contact route */}
      {location.pathname !== "/contact" && <FooterContact />}

      <FooterSocialLinks />
    </footer>
  );
}
